import { Field } from "formik";
import React from "react";
import { ReactComponent as SquareArrow } from "../../icons/squareArrow.svg";
import { classes } from "../../utils/Classes";
const RememberMe = (props) => {
  const { values } = props;
  const isSelected = values.rememberMe?.includes("rememberMe");
  const { maxHeightTrans } = classes;
  return (
    <div>
      <div className="block font-medium text-black mb-3">
        <span>Remember me</span>
      </div>
      <div role="group" className="flex flex-col">
        <label
          className={`border-pearlGray gap-2 text-sm text-black w-full h-14 border  flex items-center px-6 cursor-pointer ${
            isSelected ? " rounded-t-md" : " rounded-md"
          }`}
        >
          <div class="relative flex">
            <Field
              className="h-4 w-4 checkbox-style"
              type="checkbox"
              name="rememberMe"
              value="rememberMe"
            />
          </div>

          <div className="flex justify-between items-center w-full">
            <span>Save my information for a faster checkout</span>
          </div>
        </label>
        <div
          className={`${maxHeightTrans} overflow-hidden rounded-b-md border-b-0 bg-whiteSmoke w-full  border-pearlGray ${
            isSelected ? "max-h-28 border p-4" : "max-h-0 border-0"
          }`}
        >
          <p className="text-sm">
            Next time you check out here or on other stores powered by Octavio,
            you’ll receive a code by text message to securely purchase with
            Octavio Pay.
          </p>
          <div className="text-[#707070] text-xs flex gap-1 mt-5">
            <span>By continuing, you agree to Shop Pay’s</span>
            <span className="underline">
              <a
                aria-label="(opens a new window)"
                href="https://www.octavio.co/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="flex content-center"
              >
                Privacy Policy
                <span className="stroke-current flex content-center flex-wrap">
                  <SquareArrow height="14px" width="14px" fill="none" />
                </span>
              </a>
            </span>
            <span>and</span>
            <span className="underline">
              <a
                aria-label="(opens a new window)"
                href="https://www.octavio.co/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="flex content-center"
              >
                Terms of Service
                <span className="stroke-current flex content-center flex-wrap">
                  <SquareArrow height="14px" width="14px" fill="none" />
                </span>
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RememberMe;
